import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const finish = (dest) => {
      window.history.replaceState(null, "", dest);
      navigate(dest, { replace: true });
    };
    if (!sessionId) {
      finish("/marketplace");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        finish("/marketplace");
      } catch {
        finish("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05050A]">
      <div className="text-center">
        <div className="w-14 h-14 border-2 border-[#00E5FF] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
        <p className="font-display uppercase tracking-[0.3em] text-[#00E5FF] text-glow-cyan text-sm">
          Taking the stage…
        </p>
      </div>
    </div>
  );
}
